export default __webpack_public_path__ + "static/media/Design-UX-UI-PT.a238b895.jpg";